/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_Agents_VInputs */

const en_home_spec_agents_v = /** @type {(inputs: Home_Spec_Agents_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP, JSON control, CLI`)
};

/**
* | output |
* | --- |
* | "MCP, JSON control, CLI" |
*
* @param {Home_Spec_Agents_VInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_agents_v = /** @type {((inputs?: Home_Spec_Agents_VInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_Agents_VInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_agents_v(inputs)
});
export { home_spec_agents_v as "home.spec.agents_v" }